<template>
    <table class="table table-bordered chart-table">
                <thead>
                    <tr class="text-center table-dark">
                        <th v-for="(item, index) in tableData">
                            {{ index }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(header, index) in tableData[indexKey]" :key="index">
                        <td class="text-center">{{ header }}</td>
                        <td class="text-right" v-for="(value, dataIndex) in tableData" v-if="dataIndex !== indexKey " :key="dataIndex">
                            {{ value[index] }}
                        </td>
                    </tr>
                </tbody>
            </table>
</template>
<script>
    export default {
        name:'chartTable',
        props: [
            'tableData'
        ],
        created() {
            this.indexKey = Object.keys(this.tableData)[0];
        },
        data() {
            return {
                indexKey:'',
            }
            
        },
    }
</script>
<style scoped>
    .table {
        width: clamp(210px, 18.2292vw, 350px);
        height: calc(100% + 1px);
        margin-top: -1px !important;
        margin-bottom: 0;
        border-color: #DDDDE3;
        border-width: 0;
        border-left-width: 1px;
    }
    .table thead {
        border-top: 1px solid #DDDDE3;
        border-bottom: 1px solid #DDDDE3;
        border-left: 0 none;
        border-right: 0 none;
    }
    .table thead th {
        width: 50%;
        height: 60px;
        padding: clamp(16px, 1.0417vw, 20px) 5px;
        background-color: #E7E7EE;
        color: #2E2E38;
        text-align: center;
        font-family: 'NanumGothic';
        font-size: clamp(12px, 0.7813vw, 15px);
        font-weight: 700;
        border-color: #DDDDE3;
        border-width: 0;
    }
    .table tbody td {
        padding: clamp(16px, 1.0417vw, 20px) 0;
        background-color: #F6F6FA;
        color: #2E2E38;
        font-family: 'NanumGothic';
        font-size: clamp(12px, 0.7813vw, 15px);
        font-weight: 700;
        vertical-align: middle;
        border-color: #DDDDE3;
        border-width: 0;
    }
    .table tbody td.text-right {
        padding-right: clamp(16px, 1.0417vw, 20px);
    }
    .table tbody tr:last-child td:last-child {
        border-radius: 0 0 10px 0;
    }
    .table thead th:not(:last-child),
    .table tbody td:not(:last-child) {
        border-right-width: 1px;
    }
    .table tbody tr:not(:last-child) {
        border-bottom: 1px solid #DDDDE3;
    }
</style>